import React from 'react';
import IframeSSO from './views/Teste/IframeSSO';

const AppTeste = () => {
  console.log('opa ta no teste');

  const handleSuccess = (token) => {
    console.log('Token recebido:', token);
  };

  const handleError = (error) => {
    console.error('Erro no SSO:', error);
  };

  return (
    <div>
      <h1>SSO Teste</h1>
      <IframeSSO onLoginSuccess={handleSuccess} onLoginError={handleError} />
    </div>
  );
};

export default AppTeste;
